/**
 * Format a number as currency
 * @param amount - The amount in cents
 * @param currency - The currency code (default: USD)
 * @returns Formatted currency string
 */
export function formatCurrency(amount: number, currency: string = 'USD'): string {
  // Convert cents to dollars
  const dollars = amount / 100;
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(dollars);
}

/**
 * Format a number as currency with no decimal places
 * @param amount - The amount in cents
 * @param currency - The currency code (default: USD)
 * @returns Formatted currency string without decimals
 */
export function formatCurrencyNoDecimals(amount: number, currency: string = 'USD'): string {
  // Convert cents to dollars
  const dollars = amount / 100;
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(dollars);
}

/**
 * Parse a currency string to cents
 * @param value - The currency string (e.g., "$10.50")
 * @returns The amount in cents
 */
export function parseCurrencyToCents(value: string): number {
  // Remove currency symbols and convert to number
  const cleaned = value.replace(/[^0-9.-]+/g, '');
  const dollars = parseFloat(cleaned);
  
  // Convert to cents and round to avoid floating point issues
  return Math.round(dollars * 100);
}